import { motion } from "framer-motion";
import { ABOUT } from "@/constants/testIds/ashwin";
import { about, wins } from "@/data/resume";

export default function About() {
  return (
    <section
      id="about"
      data-testid={ABOUT.root}
      className="py-24 md:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-12 gap-y-12 md:gap-x-16">
        <div className="col-span-12 md:col-span-4">
          <div className="text-xs font-mono-editorial uppercase text-[color:var(--muted)] tracking-[0.15em] mb-6">
            02 — About
          </div>
          <h2 className="font-display text-5xl md:text-6xl font-light tracking-tight leading-[0.95]">
            The <span className="font-serif-accent italic text-[color:var(--accent)]">strategist</span> who thinks like a <span className="font-serif-accent italic">marketer</span>.
          </h2>
        </div>

        <div className="col-span-12 md:col-span-7 md:col-start-6">
          <div className="space-y-6 text-lg md:text-xl leading-relaxed text-[color:var(--charcoal)]/90">
            {about.map((p, i) => (
              <motion.p
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.7, delay: i * 0.1 }}
              >
                {p}
              </motion.p>
            ))}
          </div>

          {/* Wins */}
          <div className="mt-16 md:mt-20 border-t border-[color:var(--border)] pt-8">
            <div className="text-xs font-mono-editorial uppercase text-[color:var(--muted)] tracking-[0.15em] mb-6">
              Recognitions
            </div>
            <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-3">
              {wins.map((w, i) => (
                <li
                  key={i}
                  className="group flex items-start gap-3 text-base leading-snug transition-transform duration-300 hover:translate-x-1"
                >
                  <span className="mt-2 w-1.5 h-1.5 bg-[color:var(--accent)] shrink-0" />
                  <span className="group-hover:text-[color:var(--accent)] transition-colors">
                    {w}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
